import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FilterPill } from 'src/app/shared/models/filter.models';

/**
 * Removable pills for the values selected in a multi-select filter, rendered under the
 * control instead of inside its trigger — a comma-separated list truncates after two or
 * three picks at sidenav width.
 *
 * The host is `display: contents` at every call site, so nothing is selected means no box
 * at all and the surrounding section's gap doesn't open up under the control.
 */
@Component({
  selector: 'app-filter-pills',
  templateUrl: './filter-pills.component.html',
})
export class FilterPillsComponent {
  @Input({ required: true }) pills!: readonly FilterPill[];
  @Input() disabled = false;
  @Output() removed = new EventEmitter<string | number>();
}
